import Lenis from "lenis";

export default class SmoothScroll {
  constructor() {
    this.lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      direction: "vertical",
      gestureDirection: "vertical",
      smooth: true,
      mouseMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 2,
      infinite: false,
    });

    this.init();
  }

  init() {
    // Start RAF loop
    this.raf();
  }

  raf(time) {
    this.lenis.raf(time);
    requestAnimationFrame((time) => this.raf(time));
  }

  // Method to get lenis instance for ScrollTrigger integration
  getLenis() {
    return this.lenis;
  }
}
